/**
 * Small read-only metadata pill — "Mood: Uplifting", "Tempo: 120 BPM", a genre tag.
 *
 * Replaces the monolith's `previewChip(c)` style helper, which was spread onto
 * ~20 bare spans. Distinct from Chip, which is interactive and selectable.
 */
import type { ReactNode } from 'react';
import { c } from '../../styles/theme';

export interface PreviewChipProps {
  children: ReactNode;
}

export default function PreviewChip({ children }: PreviewChipProps) {
  return (
    <span
      style={{
        fontSize: 11,
        color: c.text2,
        background: c.surface1,
        border: `1px solid ${c.border}`,
        borderRadius: 999,
        padding: '5px 11px',
      }}
    >
      {children}
    </span>
  );
}
